export interface INavigationRoute {
  name: string
  displayName: string
  meta: { icon: string }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
      },
    },
    {
      name: 'admin-panel',
      displayName: 'Admin Panel',
      meta: {
        icon: 'admin_panel_settings',
      },
      children: [
        {
          name: 'admin-panel-dashboard',
          displayName: 'menu.dashboard',
          meta: {
            icon: 'vuestic-iconset-dashboard',
          },
        },
        {
          name: 'license-requests',
          displayName: 'menu.license-requests',
          meta: {
            icon: 'mso-key',
          },
        },
        {
          name: 'users-admin',
          displayName: 'menu.users',
          meta: {
            icon: 'group',
          },
        },
        {
          name: 'template-plans-list',
          displayName: 'menu.template-plans',
          meta: {
            icon: 'local_mall',
          },
        },
        {
          name: 'admin-resolution-center',
          displayName: 'menu.resolutionCenter',
          meta: {
            icon: 'support_agent',
          },
        },
        {
          name: 'admin-purchased-licenses',
          displayName: 'menu.issuedLicenses',
          meta: {
            icon: 'vpn_key',
          },
        },
        {
          name: 'admin-manage-features',
          displayName: 'menu.manageFeatures',
          meta: {
            icon: 'tune',
          },
        },
        {
          name: 'admin-manage-services',
          displayName: 'menu.manageServices',
          meta: {
            icon: 'extension',
          },
        },
        {
          name: 'admin-log-monitor',
          displayName: 'menu.logMonitor',
          meta: {
            icon: 'monitor_heart',
          },
        },
        {
          name: 'admin-mfa-authenticator',
          displayName: 'menu.mfaAuthenticator',
          meta: {
            icon: 'security',
          },
        },
        {
          name: 'admin-updates',
          displayName: 'menu.updates',
          meta: {
            icon: 'update',
          },
        },
      ],
    },
    {
      name: 'user-resolution-center',
      displayName: 'menu.mySupportTickets',
      meta: {
        icon: 'contact_support',
      },
    },
    {
      name: 'license-requests-user',
      displayName: 'menu.licenseRequests',
      meta: {
        icon: 'vpn_key',
      },
    },
    {
      name: 'projects',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
      },
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: {
        icon: 'shopping_cart',
      },
    },
    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
      },
    },
    {
      name: 'threat-intelligence',
      displayName: 'menu.threatIntelligence',
      meta: {
        icon: 'security',
      },
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
      },
    },
    {
      name: 'updates',
      displayName: 'menu.updates',
      meta: {
        icon: 'update',
      },
    },
  ] as INavigationRoute[],
}
